export const COMPARE_CHART_LEGENDS = `comapre-chart-legends`;
export const LABEL_OF_LEGEND = 'label-of-legend';
export const LABEL_OF_LEGEND_ACTIVE = 'label-of-legend-active';
export const LABEL_TEXT = `label-text`;



// WEBPACK FOOTER //
// ./src/features/home/components/constants/CompareChartLegendsConstants.js